import script from "./PublicAPIKeysComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicAPIKeysComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__